export const isEmbedMenuDisabled = (cards?: string[]) => cards?.length === 0
